import script from "./review-card.vue?vue&type=script&setup=true&lang=js"
export * from "./review-card.vue?vue&type=script&setup=true&lang=js"

import "./review-card.vue?vue&type=style&index=0&id=9c9b9670&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c9b9670"]])

export default __exports__